import { BillingStatementTag, QuiltedHealthCodeSystems } from "@/fhir/enums/quilted-health";
import { joinTokenString } from "@/utils/medplum";

/**
 * The archive tag as a `system|code` token. Used with the `_tag:not` modifier to exclude archived
 * statements and with plain `_tag` to select only them. Both halves are non-empty enum members, so
 * `joinTokenString` always returns a string here.
 */
export const ARCHIVED_STATEMENT_TAG_QUERY = joinTokenString(
  QuiltedHealthCodeSystems.BillingStatementTags,
  BillingStatementTag.Archived,
) as string;

/** The soft-delete tag as a `system|code` token, used the same way as the archive token. */
export const DELETED_STATEMENT_TAG_QUERY = joinTokenString(
  QuiltedHealthCodeSystems.BillingStatementTags,
  BillingStatementTag.Deleted,
) as string;

/**
 * Which slice of statements to fetch. Both the archive and soft-delete tags are carried on the
 * resource, so every scope resolves to a search modifier rather than a pass over the results: the
 * excluded rows are never returned to filter on.
 *
 * The scopes are mutually exclusive because the drawer offers Archived and Deleted as alternative
 * views rather than additive narrowings. Deleted statements are excluded from both other scopes, so
 * a statement that was archived and then deleted appears only under `DeletedOnly`.
 */
export const STATEMENT_SCOPE = {
  /** Statements carrying neither the archive nor the delete tag. The default list. */
  Active: "active",
  /** Statements carrying the archive tag and not the delete tag. */
  ArchivedOnly: "archived-only",
  /** Statements carrying the delete tag, archived or not. */
  DeletedOnly: "deleted-only",
} as const;
